require("./lightbox.scss");

(function ($) {
    $(function () {
        $(document).on("click",
            "*[data-toggle='lightbox']",
            function () {
                const $this = $(this);
                const url = $this.data("target-url");
                const width = $this.data("lightbox-width")
                    ? $this.data("lightbox-width")
                    : "800px";
                const height = $this.data("lightbox-height")
                    ? $this.data("lightbox-height")
                    : "600px";

                $.colorbox({
                    href: url,
                    iframe: true,
                    width: width,
                    height: height,
                    opacity: 0.95,
                    fixed: true,
                    transition: "none"
                });
            });
    });

    $(document)
        .bind("cbox_complete",
            function () {
                $("body").addClass("fixed");
            })
        .bind("cbox_cleanup",
            function () {
                $("body").removeClass("fixed");
            });
})(jQuery);